export enum NoteTypes {
  Organization = 'mongo::organization',
  Product = 'mongo::product',
  Coupons = 'coupon',
}
